import { scheduleTask } from 'ember-lifeline';

export function scrollRhsToTop(context): void {
  scheduleTask(context, 'render', () => {
    document.getElementById('rhs')?.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
